import { render, staticRenderFns } from "./cpt-chart-column-option.vue?vue&type=template&id=ec18d750&scoped=true"
import script from "./cpt-chart-column-option.vue?vue&type=script&lang=js"
export * from "./cpt-chart-column-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec18d750",
  null
  
)

export default component.exports